import AnimatedNumber from './components/Animated-Number';

export default AnimatedNumber;



// WEBPACK FOOTER //
// ./src/lib/index.js